import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, FlexBox } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import * as React from 'react';
import styles from './transferToAgentSelectItem.module.scss';
export const TransferToAgentSelectItem = ({ item, onSelect, disabled, }) => {
    const rootClass = classNames({
        [styles.disabled]: disabled,
        [styles.rootWorking]: item.presence.status === 'working',
        [styles.rootOffline]: item.presence.status === 'offline',
        [styles.rootAway]: item.presence.status === 'away',
    }, styles.root);
    return (_jsxs(FlexBox, Object.assign({ alignItems: "center", padding: "200 300", gap: "250", className: rootClass, role: "menuitem", "aria-disabled": disabled, onClick: () => onSelect(item) }, { children: [_jsxs("div", Object.assign({ className: styles.slotStart }, { children: [_jsx("div", { className: styles.presenceDot }), _jsx(Avatar, { user: Object.assign(Object.assign({}, item), { avatar_url: item.avatarUrl }) })] })), _jsx("div", Object.assign({ className: styles.slotMiddle }, { children: item.name })), _jsx("div", Object.assign({ className: styles.slotEnd, onClick: (e) => e.stopPropagation() }, { children: item.actions }))] })));
};
